export default "__VITE_ASSET__oa2hYaMw__"